import { Make } from "./make";
import { MainGroup } from "./mainGroup";
import { Series } from "./series";
import { Signals } from "./signals";

export class UpdateExistingScopePatternRequest {
    scopePatternId?: number;
    scopePatternDisplayNumber?: string;
    scopePatternTitle?: string;
    make?: Make;
    mainGroup?: MainGroup;
    releaseDate?: string;
    splDocumentName?: string;    
    isActive?: boolean;
    deactivateComments?: string;
    createdTs?: string;
    updatedTs?: string;
    series?: Series[];
    signals?: Signals[];
   
}